import { combineReducers } from 'redux';

import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import { NormalizedEvent } from '../models/normalized/normalizedEvent';
import { ById } from '../store/normalizedState';

import * as ReducerHelper from './reducerHelper';

function allIdsReducer(state: string[] = [], action: AllActions): string[] {
  switch (action.type) {
    case InternalActionTypes.EventLoaded:
      return action.result.entities.events[Object.keys(action.result.entities.events)[0]].archived
        ? ReducerHelper.addAllIds(state, action.result.entities.events)
        : state;
    case InternalActionTypes.ArchivedEventsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.events);
    case InternalActionTypes.EventArchived:
      return ReducerHelper.addAllIds(state, action.result.entities.events);
    case InternalActionTypes.EventUnarchived:
      return ReducerHelper.removeId(state, action.result.result);
    case InternalActionTypes.EventArchivedActionsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.events);
    default:
      return state;
  }
}

function byIdReducer(state: ById<NormalizedEvent> = {}, action: AllActions): ById<NormalizedEvent> {
  switch (action.type) {
    case InternalActionTypes.EventLoaded:
      return action.result.entities.events[Object.keys(action.result.entities.events)[0]].archived
        ? ReducerHelper.updateAll(state, action.result.entities.events)
        : state;
    case InternalActionTypes.ArchivedEventsLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.events);
    case InternalActionTypes.EventArchived:
      return ReducerHelper.updateAll(state, action.result.entities.events);
    case InternalActionTypes.EventUnarchived:
      return ReducerHelper.removeItem(state, action.result.result);
    case InternalActionTypes.EventArchivedActionsLoaded:
      return ReducerHelper.updateItemByFunc(
        state,
        event => ({
          ...event,
          eventActions: action.result.result,
        }),
        action.eventId.toLowerCase(),
      );
    case InternalActionTypes.EventArchivedParticipantsLoaded:
      return ReducerHelper.updateItemByFunc(
        state,
        event => ({
          ...event,
          participants: ReducerHelper.mergeArrays(event.participants, action.result.result),
        }),
        action.eventId.toLowerCase(),
      );
    case InternalActionTypes.EventArchivedVideosLoaded:
      return ReducerHelper.updateItemByFunc(
        state,
        event => ({
          ...event,
          eventVideos: action.result.result,
        }),
        action.eventId.toLowerCase(),
      );
    case InternalActionTypes.UserDeleted:
      return Object.values(state).reduce((result, item) => {
        // eslint-disable-next-line no-param-reassign
        result[item.id] = { ...item, assignee: item.assignee === action.meta.userId ? undefined : item.assignee };

        return result;
      }, {});
    default:
      return state;
  }
}

export const archivedEventsReducer = combineReducers({
  allIds: allIdsReducer,
  byId: byIdReducer,
});
